import { GetStaticPaths, GetStaticProps } from 'next';
import { getLocalePaths } from '@i18n';
import TermsMarkdown from '@components/pages/terms';

const TermsPage: React.FC = () => {
    return <TermsMarkdown />;
};

export default TermsPage;

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};
